
enum ECurrency {
  MXN = 'MXN',
  USD = 'USD'
}

export default ECurrency;